import React from 'react';
import { cssVar, Box } from '@cad-arc';

export function TabIndented(props: React.PropsWithChildren<object>): React.ReactElement {
    return (
        // We use a `style` attribute here instead of `ml` styled props
        // for extra specificity (since `Stack`s apply styles to children
        // with high specificity selectors)
        <Box style={{ marginLeft: cssVar('arc.space.2') }}>{props.children}</Box>
    );
}
